/* istanbul ignore file */

export enum ActionType {
    SetField = 1,
    StyleFieldColor = 2,
    SetMapPinColor = 3,
    SendEmail = 4,
}
